import directoryDemoQueryMixins from "../../../libs/directory-demo-query-mixins";
export default {
  name: "index-query",
  mixins: [directoryDemoQueryMixins],
  methods: {
    /**
     * @param {Event} e
     * @param {string} [term=undefined]
     */
    search: function search(e, term) {
      if (term === undefined) {
        term = this.term;
      }
      this.showSuggestions = false;
      window.location = '/directory-demo/search?' + $.param({
        query: term
      });
    }
  }
};